import ErpStockList from "./list";


if (document.body.getAttribute("data-current-path") === "erp/stock") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new ErpStockList();
    }
}